import React, { useState, useEffect } from "react";
import Notification from "../Notification.jsx";
import Navbar from "../Navbar.jsx";
import Foooter from "../Foooter.jsx";
import FooterMovil from "../FooterMovil.jsx";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import { useAuth } from "../../context/AuthContext.js";
import { useNavigate } from "react-router-dom";
import "../../style/Notifications.css";
import api from "../../utils/apiClient";
import { Spin, Modal } from 'antd';
import CompraNotification from '../CompraNotifications.jsx';
import AbonoNotification from '../AbonoNotifications.jsx';
import CreditoNotification from '../CreditoNotifications.jsx';
import CreditoNotificationOverview from '../CreditoNotificationOverview.jsx';

function Notifications() {
  const { authToken, logout } = useAuth();
  const [loading, setLoading] = useState(true);
  const [notis, setNotis] = useState([]);
  const [username, setUsername] = useState("");
  const [, setError] = useState(null);
  const [selectednoti, setSelectedNoti] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [notificationType, setNotificationType] = useState('Compra'); // Default type

  const navigate = useNavigate();

  const getuser = async () => {
    try {
      const response = await api.get("usuario/getbyToken");
      setUsername(response.data.nombre);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch data");
    }
  };

  const fetchNotifications = async (type) => {
    setLoading(true);
    setNotificationType(type);

    let url = '';
    switch (type) {
      case 'Compra':
        url = "notificaciones/compras";
        break;
      case 'Abono':
        url = "notificaciones/abonos";
        break;
      case 'Credito':
        url = "solicitudes/Admin/credito";
        break;
      default:
        url = "notificaciones/compras";
    }

    try {
      const res = await api.get(url);
      const notidata = res.data;
      setNotis(notidata);
      if (notidata.length !== 0) {
        setNewSelectedNoti(notidata[0]);
      } else {
        setSelectedNoti(null);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const deleteNotification = async (id) => {
    try {
      await api.delete("notificaciones/borrar/" + id);
      setNotis(notis.filter(noti => noti._id !== id));
      if (selectednoti && selectednoti._id === id && notis.length > 0) {
        setSelectedNoti(notis[0]);
      }
    } catch (error) {
      console.error("Error deleting notification:", error);
    }
  };

  useEffect(() => {
    const fetchAllCarros = async () => {
      setLoading(true);
      if (authToken !== null) {
        await getuser();
        await fetchNotifications('Compra');
      } else {
        navigate("/");
      }
      setLoading(false);
    };
    fetchAllCarros();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, navigate]);

  const setNewSelectedNoti = (noti) => {
    setSelectedNoti(noti);
    setDocuments(noti.payload || noti.documentos || []);
  };

  const showDocuments = () => {
    Modal.info({
      title: 'Documentos',
      content: (
        <div>
          {documents.map((doc, index) => (
            <a key={index} href={doc.url || doc} target="_blank" rel="noopener noreferrer" style={{ display: 'block', marginBottom: '10px' }}>
              {doc.name || `Documento ${index + 1}`}
            </a>
          ))}
        </div>
      ),
      onOk() {},
    });
  };

  const renderNotificationContent = () => {
    if (!selectednoti) {
      return (
        <div className="noti-detail-empty">
          <p>Selecciona una notificación para ver los detalles</p>
        </div>
      );
    }

    const tipoNotificacion = selectednoti.Tipo || selectednoti.tipo;

    switch (tipoNotificacion) {
      case 'Compra':
        return <CompraNotification noti={selectednoti} />;
      case 'Abono':
        return <AbonoNotification noti={selectednoti} showDocuments={showDocuments} />;
      case 'Credito':
        return <CreditoNotification noti={selectednoti} showDocuments={showDocuments} />;
      default:
        return <div className="column-content">Tipo de notificación no soportado</div>;
    }
  };

  return (
    <>
      <Navbar />
      <div className="containers">
        <div className="main-container-admin-a">
          <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info-all">
            <AdminSidebarDropdown onLogout={handleLogout} />

            <div className="notifications-admin-page">
              <div className="noti-header">
                <h2 className="noti-page-title">Notificaciones</h2>
                <p className="noti-subtitle">
                  Revisa solicitudes de compra, abono y crédito de tus clientes
                </p>
              </div>

              <div className="noti-tabs" role="tablist">
                <button
                  type="button"
                  role="tab"
                  aria-selected={notificationType === "Compra"}
                  className={`noti-tab ${notificationType === "Compra" ? "active" : ""}`}
                  onClick={() => fetchNotifications("Compra")}
                >
                  Solicitud de compra
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={notificationType === "Abono"}
                  className={`noti-tab ${notificationType === "Abono" ? "active" : ""}`}
                  onClick={() => fetchNotifications("Abono")}
                >
                  Solicitud de abono
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={notificationType === "Credito"}
                  className={`noti-tab ${notificationType === "Credito" ? "active" : ""}`}
                  onClick={() => fetchNotifications("Credito")}
                >
                  Solicitud de crédito
                </button>
              </div>

              {loading ? (
                <div className="noti-loading">
                  <Spin size="large" />
                </div>
              ) : notis.length === 0 ? (
                <div className="noti-empty">
                  <div className="noti-empty-icon">
                    <img src="icons/campana-dark.png" alt="" />
                  </div>
                  <p className="noti-empty-text">
                    No hay notificaciones de {notificationType.toLowerCase()}
                  </p>
                  <p className="noti-empty-sub">
                    Las nuevas solicitudes aparecerán aquí automáticamente
                  </p>
                </div>
              ) : (
                <div className="noti-layout">
                  <div className="noti-list-wrap">
                    <div className="noti-list-header">
                      <span className="noti-list-count">{notis.length}</span>
                      <span>
                        {notis.length === 1 ? "notificación" : "notificaciones"}
                      </span>
                    </div>
                    <div className="noti-list">
                      {notis.map((noti) => (
                        <div
                          className={`overview-item-n ${
                            selectednoti && selectednoti._id === noti._id
                              ? "selected"
                              : ""
                          }`}
                          key={noti._id}
                          onClick={() => setNewSelectedNoti(noti)}
                        >
                          {noti.tipo === "Credito" ? (
                            <CreditoNotificationOverview
                              noti={noti}
                              onDelete={deleteNotification}
                              isSelected={
                                selectednoti &&
                                selectednoti._id === noti._id
                              }
                              onSelect={() => setNewSelectedNoti(noti)}
                            />
                          ) : (
                            <Notification
                              noti={noti}
                              onDelete={deleteNotification}
                              isSelected={
                                selectednoti &&
                                selectednoti._id === noti._id
                              }
                              onSelect={() => setNewSelectedNoti(noti)}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="noti-detail">{renderNotificationContent()}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default Notifications;
